import classNames from 'classnames'
import React, { useState } from 'react'
import closeModalIcon from '../../assets/closeModal.svg'

interface AvatarItem {
  index: number
  image: string
}

interface Props {
  isOpen: boolean
  closeModal: () => void
  dataAvatar: AvatarItem[]
  newImage:number
  setNewImage:(id: number)=>void
  updateAvatar?:(avatarId:number) =>Promise<void>
}

const ImageUserUpdate: React.FC<Props> = ({ 
  isOpen, closeModal , newImage, setNewImage,
   updateAvatar , dataAvatar
  }) => {
  
  if (!isOpen) return null

  const [selectedImageId, setSelectedImageId]=useState(newImage)

  const setNewImageAndCloseModal =  () => {
    if (selectedImageId !== null) {
      const selectedImage = dataAvatar.find((image: AvatarItem) => image.index === selectedImageId)
      if (!selectedImage) return
        if(updateAvatar)
        {
           updateAvatar(selectedImageId)
        }
        setNewImage(selectedImageId)
        closeModal()
     
    }
  }

  return (
    <div>
      <div className={classNames('justify-center items-center flex fixed inset-0 z-50 bg-[#4945c12f] backdrop-blur-sm')}>
        <div className="relative my-6 mx-auto max-w-3xl">
          
        <div className={classNames(' rounded-2xl shadow-xl relative   flex flex-col w-[452px] sm:w-[350px] h-[560px]  bg-[#FFFFFF]',)}>
          
        <img
            src={closeModalIcon}
            width={20}
            height={20}
            onClick={() => {
              closeModal()
            }}
            className="right-8 top-6 absolute hover:cursor-pointer"
          />

          <div className=" mt-10 h-full  no-scrollbar overflow-y-auto">
            <div className="flex flex-wrap justify-center">
              {dataAvatar.map((imageList: any, index: number) => (
                <div key={index}>
                  
                  <img
                    src={imageList.image}
                    className={`w-[75px] h-[75px] m-5 sm:m-2 cursor-pointer ${selectedImageId === imageList.index ? 'border-4 rounded-full border-[#4945c1]' : ''}`}
                    onClick={() => {
                      setSelectedImageId(imageList.index)}}
                    alt='choix des avatars'
                  />
                </div>
              ))}
            </div>
          </div>
            <button
              className="bg-[#4743C9] text-white font-bold text-[20px] w-[70%] rounded-xl py-4  mx-auto my-6"
              onClick={()=>{
                setNewImageAndCloseModal()
                
            }}
            >
              Ajouter
            </button>
        </div>

          
        </div>
      </div>
    </div>
  )
}

export default ImageUserUpdate
